export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"M9 6v2H3V6zM3 16h18v2H3zm12-5v2H3v-2z\"/>"
};